import { VFC } from 'react'
import { FeedbackCard } from 'src/compositions/Feedback/FeedbackModal/FeedbackCard'
import { FeedbackRoom, Room } from 'src/models/Room'
import { SWRInfiniteResponse } from 'swr/infinite'

type SubMenuFeedbackProps = {
  room: Room
  toggleSubMenu: VoidFunction
  mutate?: SWRInfiniteResponse<Room>['mutate']
  showProfile: (userId: number) => void
}

export const FeedbackTab: VFC<SubMenuFeedbackProps> = ({
  room,
  toggleSubMenu,
  mutate,
  showProfile,
}) => {
  const counter = room.counters[0]

  const onSubmitted = () => {
    if (mutate) mutate()
    toggleSubMenu()
  }

  const roomToFeedbackRoom = (room: Room): FeedbackRoom => {
    return {
      id: room.id,
      uniqueId: room.uniqueId,
      firstMessageSentAt: room.firstMessageSentAt,
      counter: { isPaidPlan: counter.isPaidPlan || false, ...counter },
      roomType: room.type,
    }
  }

  return (
    <FeedbackCard
      item={roomToFeedbackRoom(room)}
      mutate={() => onSubmitted()}
      isTab={true}
      onClickProfile={showProfile}
    />
  )
}
